export default {
  created() {
    this.cssClasses = this.targetClasses;
    this.userCssClasses = this.targetClasses;
    if (this.config) {
      this.$set(this.config, "cssClasses", this.targetClasses);
      this.$set(this.config, "userCssClasses", this.targetClasses);
    }
  },
  data() {
    return {
      targetClasses: document.getElementById("target_classes")
        ? JSON.parse(document.getElementById("target_classes").textContent)
        : {},
      cssClasses: {},
      userCssClasses: {},
    };
  },
};
